<template>
  <div class="slds-page-header slds-page-header_related-list">
    <div class="slds-page-header__row">
      <template v-if="mode">
        <div class="slds-page-header__col-title">
          <nav role="navigation" aria-label="Breadcrumbs">
            <ol class="slds-breadcrumb slds-list_horizontal slds-wrap">
              <li class="slds-breadcrumb__item">
                <router-link to='/preview' tag="a">{{ $t('sections.fastCounter') }}</router-link>
              </li>
              <li class="slds-breadcrumb__item">
                <a class="current">{{ $t(`fastCounter.${mode}Preview`) }}</a>
              </li>
            </ol>
          </nav>
          <div class="slds-media">
            <div class="slds-media__body">
              <div class="slds-page-header__name">
                <div class="slds-page-header__name-title">
                  <h1>
                    <span v-if="preview.id" class="slds-page-header__title slds-truncate" :title="`${this.preview.id} - ${this.preview.name}`">
                      <span>{{preview.id}} - {{preview.name}}</span>
                    </span>
                    <span class="slds-page-header__title slds-truncate" :title="$t('fastCounter.newPreview')" v-else>{{$t('fastCounter.newPreview')}}</span>
                  </h1>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="slds-page-header__col-actions">
          <div class="slds-page-header__controls">
            <div class="slds-page-header__control">
              <ul class="slds-button-group-list">
                <li>
                  <button class="slds-button slds-button_neutral" :disabled="loading" @click="$emit('openEditMode')" v-if="checkPermission('MANAGE_FAST_COUNTER') && isView">
                    {{ $t('action.edit') }}
                  </button>
                </li>
                <li>
                  <button class="slds-button slds-button_neutral" :disabled="loading" @click="$emit('cancel')" v-if="checkPermission('MANAGE_FAST_COUNTER') && isEdit">
                    {{ $t('action.cancel') }}
                  </button>
                </li>
                <li>
                  <button class="slds-button slds-button_neutral" :disabled="loading" @click="$emit('save')" v-if="checkPermission('MANAGE_FAST_COUNTER') && isCreate">
                    {{ $t('action.save') }}
                  </button>
                </li>
                <li>
                  <button class="slds-button slds-button_neutral" :disabled="loading" @click="$emit('update')" v-if="checkPermission('MANAGE_FAST_COUNTER') && isEdit">
                    {{ $t('action.save') }}
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </template>
      <content-placeholders v-else>
        <content-placeholders-heading img />
      </content-placeholders>
    </div>
  </div>
</template>
<script>
import HasMode from '../utils/HasMode'
import CheckPermission from '../utils/CheckPermission'
export default {
  mixins: [CheckPermission, HasMode],
  props: {
    preview: Object,
    previewId: Number,
    loading: Boolean,
    mode: String
  }
}
</script>
<style lang="scss" scoped>
  a.current {
    cursor: default;
    color: #000000;
  }
</style>
